import { useState, useEffect } from 'react'
import { supabase } from '../lib/supabase'

export default function VersionHistory({ projectId, onRestore }) {
  const [versions, setVersions] = useState([])
  const [loading, setLoading] = useState(true)
  const [restoring, setRestoring] = useState(null)

  useEffect(() => { if (projectId) loadVersions() }, [projectId])

  async function loadVersions() {
    const { data } = await supabase
      .from('project_versions')
      .select('*')
      .eq('project_id', projectId)
      .order('version_number', { ascending: false })
      .limit(20)
    setVersions(data || [])
    setLoading(false)
  }

  async function restoreVersion(version) {
    setRestoring(version.id)
    onRestore(version.content)
    // Save as new version
    const { data: latest } = await supabase
      .from('project_versions')
      .select('version_number')
      .eq('project_id', projectId)
      .order('version_number', { ascending: false })
      .limit(1).single()

    await supabase.from('project_versions').insert({
      project_id: projectId,
      version_number: (latest?.version_number || 0) + 1,
      content: version.content,
      message: `Restored from v${version.version_number}`,
    })
    await loadVersions()
    setRestoring(null)
  }

  if (loading) return <div style={{ padding: 16, fontFamily: 'var(--font-mono)', fontSize: 11, color: 'var(--text2)' }}>Loading...</div>

  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <div style={{ padding: '10px 14px', borderBottom: '1px solid var(--border)', fontFamily: 'var(--font-mono)', fontSize: 10, color: 'var(--text2)', letterSpacing: 2 }}>
        VERSION HISTORY ({versions.length})
      </div>
      <div style={{ flex: 1, overflowY: 'auto' }}>
        {versions.length === 0 ? (
          <div style={{ padding: 20, textAlign: 'center', fontFamily: 'var(--font-mono)', fontSize: 11, color: 'var(--text2)' }}>
            No versions saved yet
          </div>
        ) : versions.map(v => (
          <div key={v.id} style={{ padding: '10px 14px', borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <div>
              <div style={{ fontFamily: 'var(--font-mono)', fontSize: 11, color: 'var(--text)', marginBottom: 2 }}>
                v{v.version_number} — {v.message}
              </div>
              <div style={{ fontFamily: 'var(--font-mono)', fontSize: 10, color: 'var(--text2)' }}>
                {new Date(v.created_at).toLocaleString()}
              </div>
            </div>
            <button onClick={() => restoreVersion(v)} disabled={restoring === v.id}
              style={{ padding: '4px 10px', background: 'transparent', border: '1px solid var(--border2)', borderRadius: 'var(--r)', color: 'var(--text2)', fontFamily: 'var(--font-mono)', fontSize: 10, cursor: 'pointer' }}
              onMouseEnter={e => { e.target.style.borderColor = 'var(--fire)'; e.target.style.color = 'var(--fire)' }}
              onMouseLeave={e => { e.target.style.borderColor = 'var(--border2)'; e.target.style.color = 'var(--text2)' }}>
              {restoring === v.id ? '...' : 'RESTORE'}
            </button>
          </div>
        ))}
      </div>
    </div>
  )
}
